"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRoleIdsToNames = exports.getRoles = exports.getUserEmailsAsSelectInputOptions = exports.getFetchPayloadRequestStatus = exports.getUsers = void 0;

var _immutable = require("immutable");

var _reselect = require("reselect");

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getUsers = function getUsers(state) {
  return state.users.get('users');
};

exports.getUsers = getUsers;
var getFetchPayloadRequestStatus = (0, _getRequestStatus.default)(_actions.PayloadActionTypes.FETCH_PAYLOAD);
exports.getFetchPayloadRequestStatus = getFetchPayloadRequestStatus;
var getUserEmailsAsSelectInputOptions = (0, _reselect.createSelector)([getUsers], function (users) {
  return users.filter(function (user) {
    return !!user.get;
  }).map(function (user) {
    return {
      text: user.get('email'),
      value: user.get('email')
    };
  }).toArray();
});
exports.getUserEmailsAsSelectInputOptions = getUserEmailsAsSelectInputOptions;

var getRoles = function getRoles(state) {
  return state.users.get('roles');
};

exports.getRoles = getRoles;
var getRoleIdsToNames = (0, _reselect.createSelector)([getRoles], function (roles) {
  return new _immutable.Map().withMutations(function (map) {
    roles.reduce(function (acc, role) {
      return acc.set(role.id, role.name);
    }, map);
    map.set('NONE', 'NONE'); // TODO: constants?
  });
});
exports.getRoleIdsToNames = getRoleIdsToNames;